var React = require('react');

function Tag (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"local_offer_24px"},React.createElement("path",{"id":"icon/maps/local_offer_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M8.79038 2.60169L15.1654 9.35169C15.4204 9.62169 15.5833 10.0042 15.5833 10.4167C15.5833 10.8292 15.4275 11.2042 15.1654 11.4742L10.207 16.7242C9.95204 17.0017 9.59788 17.1667 9.20829 17.1667C8.81871 17.1667 8.46454 17.0017 8.20954 16.7317L1.83454 9.98169C1.57246 9.70419 1.41663 9.32919 1.41663 8.91669V3.66669C1.41663 2.84169 2.05413 2.16669 2.83329 2.16669H7.79163C8.18121 2.16669 8.53538 2.33169 8.79038 2.60169ZM2.83329 4.79169C2.83329 5.41419 3.30788 5.91669 3.89579 5.91669C4.48371 5.91669 4.95829 5.41419 4.95829 4.79169C4.95829 4.16919 4.48371 3.66669 3.89579 3.66669C3.30788 3.66669 2.83329 4.16919 2.83329 4.79169Z","fill":"#42C093"})));
}

Tag.defaultProps = {"width":"17","height":"19","viewBox":"0 0 17 19","fill":"none"};

module.exports = Tag;

Tag.default = Tag;
